import React, {useEffect} from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';
import SineWave from '../../../utils/sine-wave';

const ns = `hero`;

const HeroV2 = props => {
	const {
		location,
		pageType,
		heroTitle,
		heroHeadline,
		heroDescription,
		bullets,
		plpHeroImages,
		heroDetails: {
			title,
			description,
			heroEyebrow,
			backgroundColor,
			image,
			anchorLink,
			anchorText,
		},
		category: {
			heroImageSourceUrlDesktop,
			heroImageSourceUrlTablet,
			heroImageSourceUrlMobile
		}
	} = props;

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--type-${ pageType }`]: pageType,
		[`${ ns }--bg-${ backgroundColor }`]: backgroundColor,
		[`${ ns }--color-white`]: true,
	});
	const [apaPromo, setApaPromo] = React.useState(null);

	let heroImages = plpHeroImages && JSON?.parse(plpHeroImages?.value);
	if (!heroImages) {
		heroImages = {
			mobile: heroImageSourceUrlMobile?.value,
			tablet: heroImageSourceUrlTablet?.value,
			desktop: heroImageSourceUrlDesktop?.value
		};
	}

	useEffect(() => {
		const heroWaveCallery = new SineWave('hero-wave', 'hero-wave-canvas');
		heroWaveCallery.init();

		// US-1212 APA Promo code

		const url = new URL(document.location);
		const params = url.searchParams;
		const utmSource = params.get('utm_source');
		const utmMedium = params.get('utm_medium');
		const utmCampaign = params.get('utm_campaign');

		if (utmSource === 'americanpregnancy.org' && utmMedium === 'referral' && utmCampaign === 'mom_and_baby' && url.pathname === '/mom-and-baby/') {
			setApaPromo(true);
		}
	}, [location]);

	return (
		<div className={`${ rootClassnames } herov2`}>
			<div className={`${ ns }__media`}>
				<picture>
					<source media={`(min-width: 1200px)`} srcSet={heroImages?.desktop} />
					<source media={`(min-width: 768px)`} srcSet={heroImages?.tablet} />
					<img
						className={rootClassnames}
						alt={heroHeadline || title}
						src={heroImages?.mobile}
						data-media
						loading={`lazy`}
						draggable={`false`}
					/>
				</picture>
			</div>
			<div className={`${ ns }__container`}>
				<div className={`container`}>
					<div className={`${ ns }__content`}>
						<h1 className={`${ ns }__title h2 color--navy`}>
							{heroHeadline || title}
						</h1>
						{!apaPromo ? (
							<>
								{(description || heroDescription) && (
									<div className={`${ ns }__description`}>
										{description || parse(heroDescription)}
										{(anchorText && anchorLink) && (
											<>
												&nbsp;
												<a style={{color: 'inherit'}} href={`#${ anchorLink }`}>{anchorText}</a>
											</>
										)}
									</div>
								)}
								{bullets && (
									<ul className={`${ ns }__bullets`}>
										{bullets && bullets.map(bullet => {
											return (
												<li className={`${ ns }__bullet`} key={bullet}>
													{bullet}
												</li>
											);
										})}
									</ul>
								)}
							</>
						) : (
							<div className={`${ ns }__description`}>
								<p>
									With products endorsed by the American Pregnancy Association, Nordic Naturals is proud to provide moms and babies with building-block nutrients to support healthy pregnancy and newborn development. *Our exceptionally pure omega-3 DHA products come in traditional fish oil and 100% vegan algae-based formulas.
								</p>
								<p>
									Use Promo Code&nbsp;
									<b>APA15OFF</b>
									&nbsp;to save 15% on select
									<br />
									supplements for pregnancy and beyond.
								</p>
								<bt />
								<img style={{width: '120px'}} src={'https://cdn.shopify.com/s/files/1/0511/3059/7560/files/logo-APA-white.png?v=1673294441'} alt={'American Pregnancy Association logo'} />
							</div>
						)}
					</div>
				</div>
			</div>
			<div id={'hero-wave'} className={`${ ns }__sinewave`}>
				<canvas id={'hero-wave-canvas'} />
			</div>
		</div>
	);
};

HeroV2.defaultProps = {
	heroDetails: {
		backgroundColor: 'Navy',
	},
};

export default HeroV2;
